import api, { pythonAPI } from "../../config/apiConfig";

const addListingData = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/addListingData", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const deleteListingData = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/deleteListingData", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getUnlistedInventory = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/getAll", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getStockReconciliation = async () => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/stock-reconciliation", {}, {
    headers: { Authorization: accessToken },
  });
  return response.data;
};

const addUnlistedInventory = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/add", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const assignUnlistedInventory = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/assign", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const updateUnlistedOrderStatus = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/order/update", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const updateUnlistedInventory = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/inventory/update", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const updateUnlistedInvestor = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/investor/update", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const softDeleteUnlistedInvestor = async (data: { investorId: number }) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/investor/delete", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const unlistedInvestorPanVerify = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/investor/panVerify", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const unlistedInvestorBankVerify = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("bank/verify", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};
  
const uploadUnlistedInventory = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/upload", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const addBrockerageLogFromFile = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/addBrockerageLogFromFile", data, {
    headers: {
      Authorization: accessToken,
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const uploadUnlistedReconciliation = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/reconciliation/upload", data, {
    headers: {
      Authorization: accessToken,
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const getUnlistedReconciliationHistory = async () => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/reconciliation/getAll", {}, {
    headers: { Authorization: accessToken },
  });
  return response.data;
};

const updateUnlistedReconciliation = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/reconciliation/update", data, {
    headers: { Authorization: accessToken },
  });
  return response.data;
};

const deleteUnlistedReconciliation = async (data: { fileName: string; reportGenerationDate: string }) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/reconciliation/delete", data, {
    headers: { Authorization: accessToken },
  });
  return response.data;
};

const getSuperAdminOpsDailyUsers = async (data: { startDate: number; endDate: number }) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/super-admin/ops/daily-users", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getSuperAdminOpsAUT = async (data: { startDate: number; endDate: number }) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/super-admin/ops/aut", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getSuperAdminOpsTransactionsInitiated = async (data: { startDate: number; endDate: number }) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/super-admin/ops/transactions-initiated", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getSuperAdminOpsKYCInitiated = async (data: { startDate: number; endDate: number }) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/super-admin/ops/kyc-initiated", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getSuperAdminOpsFamilyData = async (data: { startDate: number; endDate: number }) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/super-admin/ops/family-data", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getSuperAdminOpsUserLogins = async (data: { startDate: number; endDate: number }) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/super-admin/ops/user-logins", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getSuperAdminOpsBestWorstHoldings = async (data: {
  startDate: number;
  endDate: number;
}) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post(
    "admin/super-admin/ops/best-worst-holdings",
    data,
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );
  return response.data;
};

export type MarketPickPayload = {
  slot: number;
  assetClass: string;
  period: string;
  displayLabel: string;
  masterId: number;
  assetName: string;
  stockSymbol?: string | null;
  isin?: string | null;
};

const updateMarketPick = async (data: {
  picks: MarketPickPayload[];
  documents?: Record<number, File>;
}) => {
  const accessToken = localStorage.getItem("accessToken");
  const formData = new FormData();
  formData.append("picks", JSON.stringify(data.picks));

  Object.entries(data.documents || {}).forEach(([slot, file]) => {
    if (file) {
      formData.append(`document_${slot}`, file);
    }
  });

  const response = await api.post("admin/curations/market-picks/update", formData, {
    headers: {
      Authorization: accessToken,
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const deleteMarketPick = async (slot: number) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post(
    "admin/curations/market-picks/delete",
    { slot },
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );
  return response.data;
};

const getMarketPicks = async () => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post(
    "user/todayBestAssets",
    {},
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );
  return response.data;
};

const downloadMarketPickDocument = async (slot: number) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post(
    "user/market-picks/document/download",
    { slot },
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );
  return response.data;
};

const sendWhatsAppMessages = async (
  messages: Array<{ mobile: string; message: string }>
) => {
  const response = await pythonAPI.post("/send_whatsapp", messages);
  return response.data;
};

const adminService = {
  addListingData,
  deleteListingData,
  getUnlistedInventory,
  addUnlistedInventory,
  assignUnlistedInventory,
  updateUnlistedOrderStatus,
  updateUnlistedInventory,
  updateUnlistedInvestor,
  softDeleteUnlistedInvestor,
  unlistedInvestorPanVerify,
  unlistedInvestorBankVerify,
  uploadUnlistedInventory,
  addBrockerageLogFromFile,
  uploadUnlistedReconciliation,
  getUnlistedReconciliationHistory,
  updateUnlistedReconciliation,
  deleteUnlistedReconciliation,
  getStockReconciliation,
  getSuperAdminOpsDailyUsers,
  getSuperAdminOpsAUT,
  getSuperAdminOpsTransactionsInitiated,
  getSuperAdminOpsKYCInitiated,
  getSuperAdminOpsFamilyData,
  getSuperAdminOpsUserLogins,
  getSuperAdminOpsBestWorstHoldings,
  updateMarketPick,
  deleteMarketPick,
  getMarketPicks,
  downloadMarketPickDocument,
  sendWhatsAppMessages,
};
export default adminService;
